import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import AdminLogin from '../components/AdminLogin';
import AdminDashboard from '../components/AdminDashboard';
import ComingSoon from '../components/ComingSoon';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [backendAvailable, setBackendAvailable] = useState(false);

  useEffect(() => {
    checkBackendAndAuth();
  }, []);

  const checkBackendAndAuth = async () => {
    try {
      await axios.get(`${API}/api/health`, { timeout: 5000 });
      setBackendAvailable(true);
      
      // Check for existing token
      const savedToken = localStorage.getItem('mindspace_token');
      const isAdmin = localStorage.getItem('mindspace_is_admin') === 'true';
      
      if (savedToken && isAdmin) {
        // Verify token is still valid
        try {
          await axios.get(`${API}/api/auth/me`, {
            headers: { Authorization: `Bearer ${savedToken}` }
          });
          setToken(savedToken);
          setIsAuthenticated(true);
        } catch {
          // Token invalid, clear it
          localStorage.removeItem('mindspace_token');
          localStorage.removeItem('mindspace_is_admin');
        }
      }
    } catch (err) {
      console.log('Backend not available');
      setBackendAvailable(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (data) => {
    if (data.is_admin) {
      setToken(data.token);
      setIsAuthenticated(true);
    } else {
      alert('You do not have admin access');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('mindspace_token');
    localStorage.removeItem('mindspace_is_admin');
    setToken(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-purple-600 mx-auto" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!backendAvailable) {
    return <ComingSoon feature="Admin Dashboard" />;
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return <AdminDashboard token={token} onLogout={handleLogout} />;
};

export default AdminPage;
